import { useI18n } from '@openclassrooms/translations/I18nProvider';

const Translate = ({
  content,
  component: Component = 'span',
  count = null,
  unsafe = false,
  with: vars = {},
  ...otherProps
}) => {
  const { translate } = useI18n();

  // eslint-disable-next-line @openclassrooms/translation-keys
  const translatedContent = translate(content, vars, count);

  if (unsafe) {
    return <Component {...otherProps} dangerouslySetInnerHTML={{ __html: translatedContent }} />;
  }
  return <span>{translatedContent}</span>;
};

export default Translate;
